<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/Text/pre2">The Players</a></div>
<div class="SOM_pre"><a href="#/Text/pre3">The Playbill - Our Focus and Intended Audience</a></div>
<div class="SOM_pre"><a href="#/Text/pre4">Spotlight - Socrates and Paul in Athens</a></div>
<div class="SOM_part"><a href="#/Text/p1">ACT I - SETTING THE STAGE</a></div>
<div class="SOM_chap"><a href="#/Text/p1chap2">1 The Comeback of Moral Apologetics</a></div>
<div class="SOM_chap"><span href="#/Text/p1chap3" title="Link target outside of Sample">2 Stubborn Moral Facts</span></div>
<div class="SOM_chap"><span href="#/Text/p1chap4" title="Link target outside of Sample">3 Moral Apologetics Before the Twentieth Century</span></div>
<div class="SOM_chap"><span href="#/Text/p1chap5" title="Link target outside of Sample">4 Moral Arguments in the Twentieth Century and Beyond</span></div>
<div class="SOM_appen"><span href="#/Text/p1chap6" title="Link target outside of Sample">Intermission - Answering Euthyphro</span></div>
<div class="SOM_part"><span href="#/Text/p2" title="Link target outside of Sample">ACT II - THE MAIN CHARACTERS</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap2" title="Link target outside of Sample">5  Moral Goodness</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap3" title="Link target outside of Sample">6 Moral Obligations</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap4" title="Link target outside of Sample">7 Moral Knowledge</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap5" title="Link target outside of Sample">8 Moral Transformation</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap6" title="Link target outside of Sample">9 Moral Providence</span></div>
<div class="SOM_part"><span href="#/Text/p3" title="Link target outside of Sample">ACT III - ENACTING THE COMEDY</span></div>
<div class="SOM_chap"><span href="#/Text/p3chap2" title="Link target outside of Sample">10 A Gala Performance</span></div>
<div class="SOM_appen"><span href="#/Text/p3chap3" title="Link target outside of Sample">Encore: A Play at Mars Hill</span></div>
<div class="SOM_appen"><span href="#/Text/p3chap4" title="Link target outside of Sample">Curtain Call</span></div>
<div class="SOM_appen"><span href="#/Text/appen5" title="Link target outside of Sample">Additional Resources</span></div>
<div class="SOM_appen"><span href="#/Text/appen6" title="Link target outside of Sample">General Index</span></div>
<div class="SOM_appen"><span href="#/Text/appen7" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/Text/appen8" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/Text/appen9" title="Link target outside of Sample">Praise for <i>The Morals of the Story</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen10" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_appen"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/Text/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?549fdcfb